export const SETTINGS_DATA_SET = 'SETTINGS_DATA_SET'
export const SETTINGS_THEME_SET = 'SETTINGS_THEME_SET'
export const DARK_SKIN = 'dark_skin'
export const LIGHT_SKIN = 'light_skin'
export const SETTINGS_DASHBOARD_DETAILS_SET = 'SETTINGS_DASHBOARD_DETAILS_SET'
export const SETTINGS_DASHBOARD_SETTINGS_SET = 'SETTINGS_DASHBOARD_SETTINGS_SET'
export const SETTINGS_GLOBAL_SETTINGS_SET = 'SETTINGS_GLOBAL_SETTINGS_SET'
export const SETTINGS_TRADER_SETTINGS_SET = 'SETTINGS_TRADER_SETTINGS_SET'
export const SETTINGS_PERFORMANCE_SETTINGS_SET = 'SETTINGS_PERFORMANCE_SETTINGS_SET'
export const SETTINGS_MENU_TOGGLE_SET = 'SETTINGS_MENU_TOGGLE_SET'
